import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { Attendance } from "@/@types/esus/Attendance";

type IndicatorEsfC7CitizenAttendancesHistoryItemProps = {
	attendance: Attendance;
};

export function IndicatorEsfC7CitizenAttendancesHistoryItem({
	attendance,
}: Readonly<IndicatorEsfC7CitizenAttendancesHistoryItemProps>) {
	return (
		<>
			<Row>
				<Col>
					<p>
						<span className="fw-bold text-primary">Equipe: </span>
						{attendance.healthTeam?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="fw-bold text-primary">Unidade: </span>
						{attendance.healthUnit?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Profissional: </span>
						{attendance.professional1?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">Categoria: </span>
						{attendance.cbo1?.description?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			{(attendance.weight || attendance.height) && (
				<Row>
					<Col>
						<p>
							<span className="fw-bold text-primary">Peso: </span>
							{`${attendance.weight ? `${attendance.weight}KG` : "N/A"}`}
						</p>
					</Col>
					<Col>
						<p>
							<span className="fw-bold text-primary">Altura: </span>
							{`${attendance.height ? `${attendance.height}CM` : "N/A"}`}
						</p>
					</Col>
				</Row>
			)}
			{(attendance.systolicBloodPressure || attendance.diastolicBloodPressure) && (
				<Row>
					<Col>
						<p>
							<span className="fw-bold text-primary">Pressão sistólica: </span>
							{`${
								attendance.systolicBloodPressure
									? `${attendance.systolicBloodPressure}`
									: "N/A"
							}`}
						</p>
					</Col>
					<Col>
						<p>
							<span className="fw-bold text-primary">Pressão diastólica: </span>
							{`${
								attendance.diastolicBloodPressure
									? `${attendance.diastolicBloodPressure}`
									: "N/A"
							}`}
						</p>
					</Col>
				</Row>
			)}
			{attendance.problems
				?.filter(
					(problem) =>
						(problem.cid && problem.cid.cidCode !== "-") ||
						(problem.ciap && problem.ciap.ciapCode !== "-")
				)
				.map((problem, index) => (
					<Row key={`attendance-problem-row-${index + 1}`}>
						<Col>
							<p>
								<span className="fw-bold text-primary">Cid: </span>
								{problem.cid?.cidCode
									? `${problem.cid.cidCode} - ${problem.cid.description}`
									: "N/A"}
							</p>
						</Col>
						<Col>
							<p>
								<span className="fw-bold text-primary">Ciap: </span>
								{problem.ciap?.ciapCode
									? `${problem.ciap.ciapCode} - ${problem.ciap.description}`
									: "N/A"}
							</p>
						</Col>
					</Row>
				))}
		</>
	);
}
